import React from "react";
import {
  MDBBtn,
  MDBCol,
  MDBContainer,
  MDBInput,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalHeader,
  MDBModalTitle,
  MDBRow,
} from "mdb-react-ui-kit";
import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";

export class GrupoEditModal extends React.Component {
  constructor(props) {
    super(props);

    const grupo = props.data || {};
    const cuentas = Array.isArray(grupo.cuentas) ? grupo.cuentas : [];

    this.state = {
      show: props.show,
      idGrupo: grupo.IDGrupo,
      nombre: grupo.nombre || "",
      selectedCuentas: cuentas.map((c) => Number(c.IDCuenta)),
      errorMsg: null,
    };
  }

  closeModal = () => {
    this.props.onClose(false);
  };

  toggleCuenta = (idCuenta) => {
    const selected = new Set(this.state.selectedCuentas);
    if (selected.has(idCuenta)) {
      selected.delete(idCuenta);
    } else {
      selected.add(idCuenta);
    }
    this.setState({ selectedCuentas: Array.from(selected) });
  };

  async doSave(event) {
    event.preventDefault();

    const nombre = this.state.nombre.trim();
    if (!nombre || this.state.selectedCuentas.length === 0) {
      return;
    }

    this.setState({ errorMsg: null });
    this.props.onLoading(true);

    const requestOptions = {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        idGrupo: this.state.idGrupo,
        nombre,
        cuentas: this.state.selectedCuentas,
      }),
    };

    let ok = false;
    let serverMsg = null;
    await doFetch("CCON", "updateGrupo", requestOptions)
      .then((response) => response.json())
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          ok = true;
        } else {
          serverMsg = data.MESSAGE || "No se pudo actualizar el grupo";
        }
      })
      .catch((error) => {
        console.error("Error al actualizar grupo:", JSON.stringify(error, null, 2));
        serverMsg = "Error de conexión al actualizar el grupo";
      })
      .finally(() => {
        this.props.onLoading(false);
      });

    if (ok) {
      this.props.onClose(true);
    } else {
      this.setState({ errorMsg: serverMsg });
    }
  }

  render() {
    return (
      <MDBModal show={this.state.show} tabIndex="-1" onHide={this.closeModal}>
        <MDBModalDialog size="lg">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Editar grupo</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={this.closeModal}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <MDBContainer fluid>
                {this.state.errorMsg && (
                  <div className="alert alert-danger mb-3" role="alert">
                    {this.state.errorMsg}
                  </div>
                )}
                <MDBRow>
                  <MDBCol size="12">
                    <MDBInput
                      id="nombre"
                      label="Nombre del grupo"
                      value={this.state.nombre}
                      onChange={(event) => this.setState({ nombre: event.target.value })}
                      className="mb-3"
                    />
                  </MDBCol>
                </MDBRow>

                <MDBRow>
                  <MDBCol size="12">
                    <label className="form-label fw-bold">Cuentas del grupo</label>
                    <div className="border rounded p-3" style={{ maxHeight: "260px", overflowY: "auto" }}>
                      {(this.props.cuentasDisponibles || []).map((cuenta) => {
                        const idCuenta = Number(cuenta.IDCuenta);
                        const checked = this.state.selectedCuentas.includes(idCuenta);
                        return (
                          <div key={idCuenta} className="form-check mb-2">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`grupo-edit-cuenta-${idCuenta}`}
                              checked={checked}
                              onChange={() => this.toggleCuenta(idCuenta)}
                            />
                            <label className="form-check-label" htmlFor={`grupo-edit-cuenta-${idCuenta}`}>
                              {cuenta.nombre}
                            </label>
                          </div>
                        );
                      })}
                      {(this.props.cuentasDisponibles || []).length === 0 && (
                        <div className="text-muted">No hay cuentas disponibles para agrupar.</div>
                      )}
                    </div>
                  </MDBCol>
                </MDBRow>

                <MDBBtn
                  className="mt-3"
                  block
                  disabled={!this.state.nombre.trim() || this.state.selectedCuentas.length === 0}
                  onClick={(event) => this.doSave(event)}
                >
                  Guardar cambios
                </MDBBtn>
              </MDBContainer>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    );
  }
}
